import { BLOCK, ELEMENT_STYLES, HIGHLIGHTS_CLASSES, TEXT, TEXT_SELECTORS } from '../constants';
export const cleanHighlightedNodes = () => {
  const previousNodesBlock = document.querySelectorAll(HIGHLIGHTS_CLASSES.BLOCK_SELECTOR);
  const previousNodesText = document.querySelectorAll(HIGHLIGHTS_CLASSES.TEXT_SELECTOR);
  previousNodesBlock.forEach(node => node.classList.remove(HIGHLIGHTS_CLASSES.BLOCK));
  previousNodesText.forEach(node => node.classList.remove(HIGHLIGHTS_CLASSES.TEXT));
};
export const highlightDomElements = accessibilityData => {
  cleanHighlightedNodes();
  if (accessibilityData?.length) {
    const newNodes = accessibilityData.map(result => ({
      element: document.querySelector(result.selector),
      type: TEXT_SELECTORS.some(selector => result.selector.includes(selector)) ? TEXT : BLOCK
    }));
    newNodes.forEach(node => {
      if (!node) return;
      node.element.classList.add(ELEMENT_STYLES[node.type]);
    });
  }
};